export default __webpack_public_path__ + "static/media/main-premium-bg-1.a14e91f5.png";